// extracted by mini-css-extract-plugin
module.exports = {"box":"InvestmentModalStepThree_box__2QD4h","active":"InvestmentModalStepThree_active__OsMPt"};